import { useContext } from 'react';
import ConfigContext from '../../contexts/ConfigContext';
import Button from '../../components/Button';
import { unableToService } from '../data/pages';

export default function UnableToService() {
  const { isDebrandedVersion } = useContext(ConfigContext);
  const { bodyText, button, heading } = unableToService;

  return (
    <>
      <p className="text-[20px] md:text-[32px] mb-10 text-black w-full">
        {heading}
      </p>
      <p className="mt-10 mb-10 text-base">{bodyText}</p>
      <Button
        title={button.title}
        action={() =>
          isDebrandedVersion
            ? window.location.assign(button.urlDebranded)
            : window.location.assign(button.url)
        }
        className="mb-4"
        data-zuko-id="unable-to-service_close"
      />
    </>
  );
}
